/**
 * BenefitSummary 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const BenefitSummaryProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '최근 1개월 요약'
      },
      {
        name: 'componentProps.description',
        label: '설명',
        control: 'TextArea',
        defaultValue: '최근 한 달간의 혜택 내역을 확인하세요'
      },
      {
        name: 'componentProps.emptyText',
        label: '데이터 없음 메시지',
        control: 'TextField',
        defaultValue: '데이터가 없습니다'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 1px 6px rgba(0, 0, 0, 0.05)'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'TextField',
        defaultValue: '0 auto'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '80vw'
      }
    ]
  },
  {
    group: '테이블 스타일',
    properties: [
      {
        name: 'style.tableBorderColor',
        label: '테이블 테두리 색상',
        control: 'ColorPicker',
        defaultValue: '#eaecef'
      },
      {
        name: 'style.tableHeaderBgColor',
        label: '테이블 헤더 배경색',
        control: 'ColorPicker',
        defaultValue: '#f8f9fa'
      },
      {
        name: 'style.tableTextColor',
        label: '테이블 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#495057'
      }
    ]
  },
  {
    group: '텍스트 스타일',
    properties: [
      {
        name: 'style.color',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#333333'
      },
      {
        name: 'style.fontFamily',
        label: '폰트',
        control: 'TextField',
        defaultValue: 'inherit'
      },
      {
        name: 'style.fontSize',
        label: '폰트 크기',
        control: 'TextField',
        defaultValue: '16px'
      }
    ]
  }
];

export default BenefitSummaryProperties; 